import { adminHttpClient } from '../../commons/adminHttpClient'
import { NamedItem } from '../../../domain/common/namedItem'

export type EEDashboardSummaryDto = {
  isEligible: boolean
  offerSameAllowance: boolean
  categorySummaries: EEDashboardCategorySummaryDto[]
}

type EEDashboardCategorySummaryDto = {
  id: string
  name: string
  icon: string
  availableAllowance: number
  monthlyAllowance: number
  allowanceFrequency: number
  startDate: Date
  endDate: Date
  hasEndPerkRunOutDaysEnded: boolean
  daysToRunOut?: number
  runOutDays: number
  eligibleExpenseTypes: NamedItem[]
}

export const getPerksEEDashboardSummary = (planPeriodId: string): Promise<EEDashboardSummaryDto> => {
  return adminHttpClient.get(`/EEDashboard/Perks/GetPerksEEDashboardSummary/${planPeriodId}`)
}
